import { render, staticRenderFns } from "./UpdateConfirmationModal.vue?vue&type=template&id=5754c541&scoped=true&"
import script from "./UpdateConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./UpdateConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateConfirmationModal.vue?vue&type=style&index=0&id=5754c541&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5754c541",
  null
  
)

export default component.exports